import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'
import { sortBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { ExpensePageSubproject } from 'modules/expenses/hooks/useExpensesListPage'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

type Props = BaseFilterProps & {
  subprojects: ExpensePageSubproject[]
}

const toOptions = (subprojects: ExpensePageSubproject[]) =>
  sortBy(subprojects, ['name'])
    .filter((subproject) => subproject.id)
    .map((subproject) => ({ label: subproject.name, value: subproject.id! }))

const subprojectFilter = ({
  subprojects,
  expensesContext,
}: Props): DataTableFilter<ExpensesExpensableFilter> => ({
  type: FilterType.Id,
  categories: [
    {
      kind: 'MultipleChoice',
      operation: 'in',
      options: toOptions(subprojects),
    },
  ],
  onUpdateValue: () => {
    trackFilters('subproject', expensesContext)
  },
  identifier: 'expensesList.subprojectFilter',
  path: 'subproject',
  title: i18n.t('expenses_v2.forms.fields.projects.subproject'),
})

export default subprojectFilter
